import type { RailwayGraph, ResourceNode } from "./graph.js";

export function renderRailwayGraphTypes(graph: RailwayGraph): string {
  const services = names(
    graph.resources.filter(
      resource => resource.type === "service" || resource.type === "database",
    ),
  );
  const databases = names(graph.resources.filter(resource => resource.type === "database"));
  const buckets = names(graph.resources.filter(resource => resource.type === "bucket"));
  const volumes = names(graph.resources.filter(resource => resource.type === "volume"));
  const resources = names(graph.resources);

  return `// Generated by Railway IaC. Do not edit by hand.
// Provides autocomplete for evaluated graph resource lookups.

import "railway/iac";

declare module "railway/iac" {
  interface RailwayIacServiceMap ${mapBody(services)}
  interface RailwayIacDatabaseMap ${mapBody(databases)}
  interface RailwayIacBucketMap ${mapBody(buckets)}
  interface RailwayIacVolumeMap ${mapBody(volumes)}
  interface RailwayIacResourceMap ${mapBody(resources)}
}
`;
}

function names(resources: ResourceNode[]): string[] {
  return [...new Set(resources.map(resource => resource.name))].sort();
}

function mapBody(names: string[]): string {
  if (names.length === 0) return "{}";
  return `{
${names.map(name => `    ${JSON.stringify(name)}: true;`).join("\n")}
  }`;
}
